import { render, staticRenderFns } from "./VerifyCard.vue?vue&type=template&id=273c4227&scoped=true&lang=true&"
import script from "./VerifyCard.vue?vue&type=script&lang=js&"
export * from "./VerifyCard.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCard.vue?vue&type=style&index=0&id=273c4227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c4227",
  null
  
)

export default component.exports